<template>
  <!-- Education Modal -->
  <v-dialog v-model="modalDialog" max-width="725px">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Group Life Assurance Information</h5>
        <button type="button" class="close" @click="method(employee)">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="postGLI">
          <div class="form-scroll">
            <div class="card">
              <div class="card-body">
                <h3 class="card-title">
                  Group Life Assurance Information
                  <a href="javascript:void(0);" class="delete-icon"
                    ><i class="fa fa-trash-o"></i
                  ></a>
                </h3>
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                      v-if="message"
                    >
                      <strong>Success!</strong> {{ message }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group form-focus focused">
                      <input
                        type="text"
                        v-model.trim="$v.fullName.$model"
                        class="form-control floating"
                        style="height: 55px !important"
                      />
                      <label class="focus-label">Nominee Name</label>
                    </div>
                    <div
                      v-if="submitted && !$v.fullName.required"
                      class="invalid-feedback"
                    >
                      Nominee is required
                    </div>
                  </div>
                  <div class="col-md-12">
														<div class="form-group">
															<label>Address <span
																	class="text-danger">*</span></label>
															<textarea class="form-control"  v-model.trim="$v.address.$model" rows="4" />
														</div>
                                                        <div v-if="submitted && !$v.address.required" class="invalid-feedback">Address is required</div>
													</div>
                  <div class="col-md-6">
                    <div class="form-group form-focus focused">
                        <!-- <input type="text"   v-model.trim="$v.startYear.$model"
																	class="form-control floating datetimepicker" style="height: 55px !important;"> -->
                        <input
                        type="text"
                        v-model.trim="$v.relationship.$model"
                        class="form-control floating"
                        style="height: 55px !important"
                      />
                      <label class="focus-label">Relationship</label>
                    </div>
                    <div
                      v-if="submitted && !$v.relationship.required"
                      class="invalid-feedback"
                    >
                      Relationship is required
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group form-focus focused">
                        <!-- <input type="text"   v-model.trim="$v.endYear.$model"
																	class="form-control floating datetimepicker" style="height: 55px !important;"> -->
                        <input
                        type="number"
                        v-model.trim="$v.percentage.$model"
                        class="form-control floating"
                        style="height: 55px !important"
                      />
                      <label class="focus-label">Percentage</label>
                    </div>
                    <div
                      v-if="submitted && !$v.percentage.required"
                      class="invalid-feedback"
                    >
                      Percentage is required
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="submit-section">
            <button class="btn btn-primary submit-btn" type="submit">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  </v-dialog>
  <!-- /Education Modal -->
</template>


<script>
import { required, sameAs } from "vuelidate/lib/validators";
import { employeeService } from "@/services/employeeService";
import Datepicker from "vuejs-datepicker";
export default {
  props: {
    model: {},
    id: 0,
    dialog: Boolean,
    method: { type: Function },
  },
  components: {
    Datepicker,
  },
  data() {
    return {
      modalDialog: this.dialog,
      employeeId: this.id,
      employee: this.model,
      fullName: this.model ? "" : this.model.fullName,
      address: this.model ? "" : this.model.address,
      relationship: this.model ? "" : this.model.relationship,
      percentage: this.model ? "" : this.modal.percentage,
      error: "",
      message: "",
      submitted: false,
    };
  },

  validations: {
    fullName: { required },
    address: { required },
    relationship: { required },
    percentage: { required },
  },
  mounted() {
    this.$emit("update:employee", this.employee);
    this.$emit("update:GLIDialog", this.dialog);

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  methods: {
    postGLI() {
      this.submitted = true;
      // console.log(this.Id);
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      if (this.model.id) {
        employeeService
          .updateEmployeeGLI(
            this.model.id,
            this.employeeId,
            this.fullName,
            this.address,
            this.relationship,
            this.percentage
          )
          .then(
            (model) => {
              this.message = "Group Life Assurance update successfully!";
              employeeService.getEmployeeDetail(this.employeeId).then(
                (model) => {
                  this.employee = model;
                  if(!this.employee.passportPhoto){
              this.employee.passportPhoto = "../../assets/profiles/avatar-02.jpg"
          }
                  if (!this.employee.employeePension) {
                    this.employee.employeePension = {
                      id: 0,
                      pensionNo: "",
                      employeeRate: 0,
                      pensionManager: "",
                    };
                  }
                  if (!this.employee.employeeStatutory) {
                    this.employee.employeeStatutory = {
                      id: 0,
                      salaryBasis: "",
                      salaryAmount: 0.0,
                    };
                  }
                },
                (error) => {
                  this.error = error;
                }
              );
            },
            (error) => {
              this.error = error;
            }
          );
      } else {
        employeeService
          .addEmployeeGLI(
            this.employeeId,
            this.fullName,
            this.address,
            this.relationship,
            this.percentage
          )
          .then(
            (model) => {
              this.message = "Group Life Assurance create successfully!";
              employeeService.getEmployeeDetail(this.employeeId).then(
                (model) => {
                  this.employee = model;
                 
                  if (!this.employee.employeePension) {
                    this.employee.employeePension = {
                      id: 0,
                      pensionNo: "",
                      employeeRate: 0,
                      pensionManager: "",
                    };
                  }
                  if (!this.employee.employeeStatutory) {
                    this.employee.employeeStatutory = {
                      id: 0,
                      salaryBasis: "",
                      salaryAmount: 0.0,
                    };
                  }
                },
                (error) => {
                  this.error = error;
                }
              );
            },
            (error) => {
              this.error = error;
            }
          );
      }
    },

    removeEducation() {
      if (this.model.id) {
        employeeService.removeEmployeeGLI(this.model.id).then(
          (id) => {
            (this.fullName = ""),
              (this.address = ""),
              (this.relationship = ""),
              (this.percentage = ""),
              (this.message = "Group Life Assurance removed successfully!");
            employeeService.getEmployeeDetail(this.employeeId).then(
              (model) => {
                this.employee = model;
                if(!this.employee.passportPhoto){
              this.employee.passportPhoto = "../../assets/profiles/avatar-02.jpg"
          }
                if (!this.employee.employeePension) {
                  this.employee.employeePension = {
                    id: 0,
                    pensionNo: "",
                    employeeRate: 0,
                    pensionManager: "",
                  };
                }
                if (!this.employee.employeeStatutory) {
                  this.employee.employeeStatutory = {
                    id: 0,
                    salaryBasis: "",
                    salaryAmount: 0.0,
                  };
                }
                if (!this.employee.employeeTax) {
                    this.employee.employeeTax = {
                      id: 0,
                      tin: "",
                      taxCode: "",
                      taxOffice: "",
                    tax: {}
                    }
                  }else{
                    this.employee.employeeTax.tax = { taxOffice: this.employee.employeeTax.taxCode, description: this.employee.employeeTax.taxOffice}
                  }
              },
              (error) => {
                this.error = error;
              }
            );
          },
          (error) => {
            this.error = error;
          }
        );
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/employees/GLIModal.vue